import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { CheckSquare, FileText, Eye, Milestone, BarChart3, FileSpreadsheet } from 'lucide-react';
import AnimateOnScroll from './AnimateOnScroll';
import { featuresSection } from '../content/landingContent';

const iconMap = {
  0: CheckSquare,
  1: FileText,
  2: Eye,
  3: Milestone,
  4: BarChart3,
  5: FileSpreadsheet
};

export const FeaturesSection = () => {
  return (
    <section id="features" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <AnimateOnScroll>
          <div className="text-center mb-20">
            <h2 className="text-2xl lg:text-3xl font-bold text-stone-900 mb-6 tracking-tight">
              {featuresSection.headline}
            </h2>
            <p className="text-lg text-stone-600 max-w-2xl mx-auto">
              {featuresSection.subheadline}
            </p>
          </div>
        </AnimateOnScroll>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuresSection.features.map((feature, index) => {
            const Icon = iconMap[index];
            return (
              <AnimateOnScroll key={index} delay={index * 100}>
                <Card 
                  className="border border-stone-200 hover:border-slate-300 transition-all duration-300 hover:shadow-md group bg-white rounded-lg"
                >
                  <CardHeader className="space-y-4">
                    <div className="w-14 h-14 rounded-lg bg-slate-100 flex items-center justify-center group-hover:bg-slate-600 transition-all duration-300 shadow-sm">
                      <Icon className="w-7 h-7 text-slate-600 group-hover:text-white transition-colors duration-300" />
                    </div>
                    <CardTitle className="text-xl font-semibold text-stone-900 group-hover:text-slate-700 transition-colors">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-stone-600 text-base leading-relaxed">
                      {feature.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </AnimateOnScroll>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;